import { useEffect, useState, useCallback } from 'react';
import { userService } from '../../Services';
import Loader from '../Common/Loader';
import Layout from '../Common/Layout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAt,
    faCopy
  } from '@fortawesome/free-solid-svg-icons';


const DSO = () => {
    const [list, setList] = useState('');
    const [loading, setLoading] = useState([]);
    const [checked, setChecked] = useState(true);

    const copyText = () => {
        navigator.clipboard.writeText(list.join(', '))
    }

    const fetchData = useCallback(async (value) => {
        setLoading(true);
        const data = await userService.getDOSemails(value);
        setList(data.list);
        setLoading(false);
      }, [])

    useEffect(() => {
        fetchData(checked);
    }, [fetchData, checked])

    return <Layout>
            <>
                <div className="top-panel">
                    <h1>
                        <FontAwesomeIcon
                            icon={faAt}
                            style={{ fontSize: 25, color: "#59748A" }}
                        />
                        DSO emails
                    </h1>
                </div>
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={checked}
                        disabled={loading}
                        onChange={(e) => setChecked(e.target.checked)}
                    />
                    <span className="switch-slider"></span>
                    Active OMs only
                </label>
                {loading ? 
                    <Loader/> : 
                    <div className="dso-list">
                        <FontAwesomeIcon
                            icon={faCopy}
                            style={{ fontSize: 20, color: "#59748A" }}
                            onClick={copyText()}
                        />
                        <textarea 
                            name="dso" 
                            rows={1}
                            defaultValue={list ? list.join('\n') : '  '} />
                    </div>
                }
            </>
        </Layout>;
    };

export default DSO;